import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { DisclosureReviewTab } from "../../../../../companies/offenlegung/DisclosureReviewTab";

const companyRoute = getRouteApi(
  "/beratung/$taxAdvisoryId/unternehmen/$companyId"
);

export const Route = createFileRoute(
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/offenlegung"
)({
  loader: async ({
    context: { queryClient, trpc },
    params: { taxAdvisoryId, companyId },
  }) => {
    void queryClient.ensureQueryData(
      trpc.disclosureReviews.listDisclosureReviews.queryOptions({
        taxAdvisoryId,
        companyId,
      })
    );
  },
  component: OffenlegungRoute,
});

function OffenlegungRoute() {
  const { taxAdvisoryId, companyId } = Route.useParams();
  const { jahr } = companyRoute.useSearch();

  return (
    <DisclosureReviewTab
      taxAdvisoryId={taxAdvisoryId}
      companyId={companyId}
      selectedYear={jahr ?? null}
    />
  );
}
